import { createClient } from "@supabase/supabase-js";

// Dedicated client for PKCE-based auth flows (e.g., password recovery).
// Some email clients / redirectors strip URL fragments (#access_token=...), which breaks
// implicit-flow recovery links. PKCE uses a query param (?code=...) instead.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
const PROJECT_ID = import.meta.env.VITE_SUPABASE_PROJECT_ID;

export const pkceSupabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    flowType: "pkce",
    // Avoid undefined behavior by not sharing the same storage key as the main client.
    // The recovery session only needs to exist for the reset flow.
    storageKey: PROJECT_ID ? `sb-${PROJECT_ID}-auth-token-pkce` : "sb-auth-token-pkce",
  },
});
